/* Campfest theme — nav + PDP size picker */
(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initNav() {
    var toggle = qs('[data-nav-toggle]');
    var nav = qs('[data-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    initDropdowns();
  }

  /* Header dropdowns (e.g. Merch → All Merch / Tees / Hoodies).
     - Mouse: opens on hover (CSS :hover) and JS keeps it open for a short grace
       period after the pointer leaves, so a slightly off diagonal move to the
       panel doesn't close it.
     - Touch / pen / no-hover devices and the mobile menu: first tap opens,
       second tap follows the parent link.
     - Keyboard: CSS :focus-within keeps it open; Escape closes.
     - Tapping/clicking outside closes any open dropdown. */
  function initDropdowns() {
    var CLOSE_DELAY = 250;
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 819px)') : null;
    var noHoverMq = window.matchMedia ? window.matchMedia('(hover: none)') : null;
    var drops = Array.prototype.slice.call(document.querySelectorAll('.nav-dropdown'));

    function isMobile() {
      return !!(mobileMq && mobileMq.matches);
    }

    drops.forEach(function (drop) {
      var trigger = drop.querySelector('[data-nav-drop]');
      if (!trigger) return;
      var closeTimer = null;
      var lastPointer = '';

      function setOpen(open) {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        drop.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      drop._setOpen = setOpen;

      drop.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || isMobile()) return;
        drops.forEach(function (d) {
          if (d !== drop && d._setOpen) d._setOpen(false);
        });
        setOpen(true);
      });
      drop.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || isMobile()) return;
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          closeTimer = null;
          setOpen(false);
        }, CLOSE_DELAY);
      });

      trigger.addEventListener('pointerdown', function (e) {
        lastPointer = e.pointerType || '';
      });
      trigger.addEventListener('touchstart', function () {
        lastPointer = 'touch';
      }, { passive: true });

      trigger.addEventListener('click', function (e) {
        var touchLike = lastPointer === 'touch' || lastPointer === 'pen' || !!(noHoverMq && noHoverMq.matches);
        lastPointer = '';
        if (!(touchLike || isMobile())) return; // mouse/keyboard on desktop: follow the link
        if (!drop.classList.contains('is-open')) {
          // First tap opens the submenu; a second tap follows the parent link.
          e.preventDefault();
          drops.forEach(function (d) {
            if (d !== drop && d._setOpen) d._setOpen(false);
          });
          setOpen(true);
        }
      });

      drop.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          setOpen(false);
          trigger.focus();
        }
      });

      drop.addEventListener('focusout', function (e) {
        if (e.relatedTarget && drop.contains(e.relatedTarget)) return;
        if (drop.classList.contains('is-open') && !isMobile()) setOpen(false);
      });
    });

    document.addEventListener('click', function (e) {
      drops.forEach(function (d) {
        if (d._setOpen && d.classList.contains('is-open') && !d.contains(e.target)) d._setOpen(false);
      });
    });
  }

  function initProductForm() {
    var section = qs('[data-product-section]');
    if (!section) return;
    var jsonEl = qs('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var form = qs('[data-product-form]', section);
    var idInput = qs('[data-variant-id]', section);
    var addBtn = qs('[data-add-to-cart]', section);
    var err = qs('[data-size-error]', section);
    var priceEl = qs('[data-product-price]', section);
    var selected = {};

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return !selected[i] || selected[i] === opt;
        });
      });
    }

    function updateUI() {
      var optionCount = product.options.length;
      var allSelected = true;
      for (var i = 0; i < optionCount; i++) {
        if (!selected[i]) allSelected = false;
      }
      var variant = findVariant();
      if (allSelected && variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? (addBtn.getAttribute('data-label') || 'Add to bag') : 'Sold out';
        }
        if (err) err.classList.remove('is-visible');
      } else if (addBtn && optionCount > 0) {
        addBtn.disabled = false;
      }
    }

    function formatMoney(cents) {
      try {
        return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    if (addBtn) addBtn.setAttribute('data-label', addBtn.textContent.trim());

    qsa('.size-grid', section).forEach(function (grid) {
      var idx = parseInt(grid.getAttribute('data-option-index'), 10);
      qsa('.size-btn', grid).forEach(function (btn) {
        btn.addEventListener('click', function () {
          qsa('.size-btn', grid).forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          selected[idx] = btn.getAttribute('data-option-value');
          var label = qs('[data-selected-option="' + idx + '"]', section);
          if (label) label.textContent = selected[idx];
          updateUI();
        });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (product.has_only_default_variant) return;
        var optionCount = product.options.length;
        for (var i = 0; i < optionCount; i++) {
          if (!selected[i]) {
            e.preventDefault();
            if (err) err.classList.add('is-visible');
            return;
          }
        }
        var variant = findVariant();
        if (!variant || !variant.available) {
          e.preventDefault();
          if (err) {
            err.textContent = 'That size is unavailable.';
            err.classList.add('is-visible');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initProductForm();
  });
})();
